import { SVGComponent } from '../types/svgComponent';

export const GlobalLine: SVGComponent = (props) => {
  return (
    <svg width="25" height="25" viewBox="0 0 16 16" {...props}>
      <path
        d="M8 14.667A6.667 6.667 0 1 1 8 1.334a6.667 6.667 0 0 1 0 13.333zM6.473 13.11a11.933 11.933 0 0 1-1.122-4.444H2.708a5.339 5.339 0 0 0 3.765 4.444zm.214-4.444A10.61 10.61 0 0 0 8 13.168a10.603 10.603 0 0 0 1.313-4.501H6.688zm6.605 0H10.65a11.931 11.931 0 0 1-1.122 4.444 5.338 5.338 0 0 0 3.765-4.444zM2.708 7.333h2.643c.084-1.54.465-3.05 1.122-4.444a5.339 5.339 0 0 0-3.765 4.444zm3.98 0h2.625A10.603 10.603 0 0 0 8 2.832a10.603 10.603 0 0 0-1.313 4.501zM9.527 2.89a11.931 11.931 0 0 1 1.122 4.444h2.643A5.34 5.34 0 0 0 9.527 2.89z"
        fill="#616161"
      />
    </svg>
  );
};
